<template>
  <div class="totalBody">
    <div class="headerBox">
      <p>领料看板</p>
      <div class="currentDate">{{ nowTime }}</div>
    </div>

    <el-row class="rows" :gutter="20">
      <el-col :span="6">
        <div class="box chart-box" style="color: #FFFFFF">
          <h4 class="chart-title">领料提示</h4>
          <div style="height: 400px;position: relative">
            <div style="display: flex;justify-content: center;flex-wrap: wrap;width: 420px;margin: 0 auto;">
              <div class="uname">张三三</div>
              <div class="uname">李四四</div>
              <div class="uname">赵六六</div>
              <div class="uname">张三三</div>
              <div class="uname">李四四</div>
              <div class="uname">张三三</div>
              <div class="uname">李四四</div>
              <div class="uname">赵六六</div>
              <div class="uname">张三三</div>
              <div class="uname">李四四</div>
              <div class="uname">李四四</div>
              <div class="uname">李四四</div>
              <div class="uname">李四四</div>
              <div class="uname">李四四</div>
              <div class="uname">李四四</div>
            </div>
            <div style="font-size: 20px;text-align: center;padding-bottom: 15px;position: absolute;bottom: 0;width: 100%;">料件已准备好，请前往领料窗领取</div>
          </div>
        </div>
      </el-col>
      <el-col :span="9">
        <div class="box reportBox">
          <h4 class="chart-title">待发料信息</h4>
          <div class="tableBox">
            <el-table :data="capacityList">
              <el-table-column align="center" prop="index" label="序号" width="76"></el-table-column>
              <el-table-column align="center" prop="userName" label="姓名" width="120"></el-table-column>
              <el-table-column align="center" prop="orderNo" label="申请单号"></el-table-column>
              <el-table-column align="center" prop="createTime" label="申请时间" width="170"></el-table-column>
              <el-table-column align="center" prop="cnt" label="申请数量" width="130"></el-table-column>
            </el-table>
          </div>
        </div>

      </el-col>
      <el-col :span="9">
        <div class="box reportBox">
          <h4 class="chart-title">缺料信息</h4>
          <div class="tableBox">
            <el-table :data="capacityList">
              <el-table-column align="center" prop="index" label="序号" width="76"></el-table-column>
              <el-table-column align="center" prop="userName" label="姓名" width="120"></el-table-column>
              <el-table-column align="center" prop="orderNo" label="申请单号"></el-table-column>
              <el-table-column align="center" prop="createTime" label="申请时间" width="170"></el-table-column>
              <el-table-column align="center" prop="cnt" label="缺料数量" width="130"></el-table-column>
            </el-table>
          </div>
        </div>

      </el-col>
    </el-row>
    <el-row class="rows" :gutter="20">
      <el-col :span="6">
        <div class="box chart-box">
          <h4 class="chart-title">今日领料情况</h4>
          <div class="tableBox">
            <el-table :data="overTimeList">
              <el-table-column align="center" prop="userName" label="类别"></el-table-column>
              <el-table-column align="center" prop="customer" label="数量"></el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
      <el-col :span="18">
        <div class="box reportBox">
          <h4 class="chart-title">待领料信息</h4>
          <div class="tableBox">
            <el-table :data="repairRateList">
              <el-table-column align="center" prop="index" label="序号" width="100"></el-table-column>
              <el-table-column align="center" prop="userName" label="姓名" width="150"></el-table-column>
              <el-table-column align="center" prop="orderNo" label="申请单号" width="180"></el-table-column>
              <el-table-column align="center" prop="createTime" label="申请时间" min-width="150"></el-table-column>
              <el-table-column align="center" prop="cnt" label="申请数量"></el-table-column>
              <el-table-column align="center" prop="sendTime" label="发料时间" min-width="150"></el-table-column>
              <el-table-column align="center" prop="sendCnt" label="发料数量"></el-table-column>
            </el-table>
          </div>
        </div>

      </el-col>
    </el-row>

  </div>
</template>

<script>
import {currentDate} from 'joysun-frame'

export default {
  name: "WmsPickScreen",
  data() {
    return {
      nowTime: currentDate(),
      capacityList: [
        {index: 1, userName: '张三三1', orderNo: 'LL1005', createTime: '09-25 12:00', cnt: 10},
        {index: 2, userName: '张三三2', orderNo: 'LL1006', createTime: '09-25 12:00', cnt: 10},
        {index: 3, userName: '张三三3', orderNo: 'LL1007', createTime: '09-25 12:00', cnt: 10},
        {index: 4, userName: '张三三4', orderNo: 'LL1008', createTime: '09-25 12:00', cnt: 10},
        {index: 5, userName: '张三三5', orderNo: 'LL1009', createTime: '09-25 12:00', cnt: 10},
      ],
      repairRateList: [
        {index: 1, userName: '人员1', orderNo: 'LL1005', createTime: '09-25 12:00', cnt: 10, sendTime: '09-25 14:59', sendCnt: 10},
        {index: 2, userName: '人员2', orderNo: 'LL1006', createTime: '09-25 12:00', cnt: 10, sendTime: '09-25 14:59', sendCnt: 10},
        {index: 3, userName: '人员3', orderNo: 'LL1007', createTime: '09-25 12:00', cnt: 10, sendTime: '09-25 14:59', sendCnt: 10},
        {index: 4, userName: '人员4', orderNo: 'LL1008', createTime: '09-25 12:00', cnt: 10, sendTime: '09-25 14:59', sendCnt: 10},
        {index: 5, userName: '人员5', orderNo: 'LL1009', createTime: '09-25 12:00', cnt: 10, sendTime: '09-25 14:59', sendCnt: 10},
      ],
      overTimeList: [
        {userName: '申请数量', customer: '110'},
        {userName: '待发数量', customer: '10'},
        {userName: '已发数量', customer: '98'},
        {userName: '缺料数量', customer: '2'},
        {userName: '缺料率', customer: '2%'}
      ]
    }
  },
  mounted() {
    document.title = '领料看板'

    setInterval(() => this.nowTime = currentDate(), 1000);

    let data = {};
    data.device_pixel_ratio = window.devicePixelRatio;
    data.outer_width = window.outerWidth;
    data.outer_height = window.outerHeight;
    data.inner_width = window.innerWidth;
    data.inner_height = window.innerHeight;
    data.screen_width = window.screen.width;
    data.screen_height = window.screen.height;
    data.user_agent = navigator.userAgent;

    this.$http('testService.browserInfo', data)
  },
}
</script>

<style scoped>
.totalBody {
  color: #ffffff;
  min-width: 1900px;
  min-height: 1080px;
  background: url('/report/bg_report.png') no-repeat;
  background-size: cover; /* 拉伸图片覆盖整个区域 */
  padding: 0px;
  overflow-x: hidden;
  overflow-y: auto;
}

.headerBox {
  width: 100%;
  height: 110px;
  background: url('/report/header.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  margin-bottom: 10px;
}

p {
  margin: 0 0 10px;
  padding-top: 25px;
}

.headerBox > p {
  text-align: center;
  font-size: 36px;
  font-weight: bold;
}

.headerBox > div {
  position: absolute;
  top: 10px;
}


.currentDate {
  font-size: 24px;
  right: 30px;
  line-height: 35px;
}

.rows {
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 20px;
}

.chart-title {
  font-weight: normal;
  font-size: 32px;
  margin-top: 0px;
  margin-bottom: 10px;
  text-align: center;
  color: #FFFFFF;
}

.chart-title:before {
  content: url('/report/title_before.png');
}

.chart-title:after {
  content: url('/report/title_after.png');
}

.box {
  background-image: url('/report/top_left.png'), url('/report/bottom_left.png'), url('/report/top_right.png'), url('/report/bottom_right.png'), url('/report/report_bg.png');
  background-repeat: no-repeat;
  background-position: top left, bottom left, top right, bottom right, top left;
  background-size: 30px 30px, 30px 30px, 30px 30px, 30px 30px, 100% 100%;
}

.reportBox {
  height: 460px;
}

.chart-box {
  height: 460px;
  width: 100%;
}

.tableBox .el-table {
  --el-table-row-hover-bg-color: #99CCFF;
}

.tableBox :deep(.el-table tr) {
  background-color: transparent;
  border: none;
}

.tableBox :deep(.el-table th, .el-table tr, .el-table td) {
  background-color: transparent;
  border-style: none;
}

.tableBox :deep(table tbody tr:nth-child(odd)) {
  background: rgba(30, 176, 252, .15);
  border: none;
}

.tableBox :deep(.el-table, .el-table__expanded-cell) {
  background-color: transparent;
  border: none;
}

.tableBox :deep(.el-table--enable-row-transition .el-table__body td, .el-table .cell) {
  background-color: transparent;
  border: none;
  padding-top: 19px;
  padding-bottom: 19px;
}

.tableBox :deep(.el-table td, thead) {
  color: #FFFFFF;
  font-size: 26px;
}

.tableBox :deep(.el-table th, thead) {
  color: #FFFFFF;
  font-size: 26px;
  padding: 5px 0;
}

.tableBox :deep(.el-table .cell) {
  line-height: 32px;
}

.el-table--border::after, .el-table--group::after, .el-table::before {
  display: none;
}

.tableBox :deep(.el-table__inner-wrapper::before) {
  content: none;
}

.uname {
  font-size: 32px;
  width: 140px;
  height: 60px;
  text-align: center;
}

</style>